import axios from 'axios';
import Helper from '@utils/misc';

const Methods = Object.freeze({ "GET": 1, "POST": 2 })



async function sendHttpRequest({ url, method = Methods.GET, token, body }) {
    //hr= handle response
    let hr = (res) => {
        if (res instanceof Error) return he(res);

        return res.data;
    }

    //he = handle error
    let he = (err) => {
        return err;
    }
    // checks for the HttpMethod and sends request to the server accordingly
    let response = (method == Methods.POST) ?
        await axios.post(url, body, {
            headers: {
                Authorization: token ? 'JWT ' + token : null
            }
        }).then((res) => hr(res)).catch((err) => he(err))
        : await axios.get(url, {
            headers: {
                Authorization: token ? 'JWT ' + token : null
            }
        }).then((res) => hr(res)).catch((err) => he(err));
    return response;
}

async function handleApi({ apiEssentials, responseVar, url, method = Methods.GET, body }) {
    apiEssentials.setLoading(true);
    // gets test details
    let responseFromServer = await sendHttpRequest({ url: url, token: apiEssentials.accessToken, method: method, body: body });
    if (!Helper.handleErrors(responseFromServer, apiEssentials.handleErrorsFunction)) return responseVar;

    // display
    responseVar = responseFromServer;

    apiEssentials.setLoading(false);
    return responseVar;
}

let ifiHttp = {
    Methods,
    sendHttpRequest,
    handleApi
}

export default ifiHttp;
